import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogConnectNewSmartlockAccountComponent } from '@app/modules/apps/components/dialog-connect-new-smartlock-account/dialog-connect-new-smartlock-account.component';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-smartlock-connection-failure',
  templateUrl: './dialog-smartlock-connection-failure.component.html',
  styleUrls: ['./dialog-smartlock-connection-failure.component.scss'],
})
export class DialogSmartlockConnectionFailureComponent implements OnInit {
  integration_id: string;

  constructor(
    public dialogRef: MatDialogRef<DialogSmartlockConnectionFailureComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() { }

  connectAccount() {
    const dialogRef = this.dialog.open(DialogConnectNewSmartlockAccountComponent, {
      width: '720px',
      maxHeight: '90vh',
      data: {
        integration_id: this.integration_id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
}
